<div class="full-page-container">
    <div class="row">
        <div class="col col-lg-8 mx-auto">
            <div class="card">
                <div class="card-header card-header-primary card-header-icon">
                    <div class="card-icon" style="width: 80px;">
                        <img src="./../../../assets/img/SABS_Logo_2022_Icon_White.png" class="material-icons"
                            style="width: 100%;" alt="">
                        <!-- <i class="material-icons">content_paste</i> -->
                    </div>
                    <h3 class="card-title" style="font-weight: 500;">Login</h3>
                </div>
                <form class="form" [formGroup]="validationForm" (ngSubmit)="formSubmit(validationForm)">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-12 mt-3">
                                <div class="form-group has-default">
                                    <div class="input-group align-items-center">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">
                                                <i class="material-icons">face</i>
                                            </span>
                                        </div>
                                        <mat-form-field [hideRequiredMarker]="true" class="flex-grow-1 mb-0">
                                            <mat-label>Username <span class="text-danger">*</span></mat-label>
                                            <input matInput formControlName="username" type="text" id="username"
                                                name="username" placeholder="eg. Smith Joe">
                                        </mat-form-field>
                                    </div>
                                    <div class="input-group align-items-center">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text empty-width">
                                            </span>
                                        </div>
                                        <p *ngIf="!validationForm.controls['username'].value && validationForm.controls['username'].touched"
                                            class="custom-error-message">
                                            Username is required
                                        </p>
                                    </div>
                                </div>

                            </div>
                            <div class="col-lg-12 mt-3">
                                <div class="form-group has-default">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">
                                                <i class="material-icons">lock</i>
                                            </span>
                                        </div>
                                        <mat-form-field [hideRequiredMarker]="true">
                                            <mat-label>Password <span class="text-danger">*</span></mat-label>
                                            <div class="password-field">
                                                <input matInput type="{{passwordFieldType}}" formControlName="password">
                                                <i class="material-icons password-field-icon"
                                                    (click)="togglePasswordFieldType()"
                                                    *ngIf="passwordFieldType == 'text'">visibility_off</i>
                                                <i class="material-icons password-field-icon"
                                                    (click)="togglePasswordFieldType()"
                                                    *ngIf="passwordFieldType == 'password'">visibility</i>
                                            </div>
                                        </mat-form-field>
                                    </div>
                                    <div class="input-group align-items-center">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text empty-width">
                                            </span>
                                        </div>
                                        <p *ngIf="!validationForm.controls['password'].value && validationForm.controls['password'].touched"
                                            class="custom-error-message">
                                            Password is required
                                        </p>
                                        <p *ngIf="validationForm.controls['password'].errors?.['minlength']"
                                            class="custom-error-message">
                                            Password must be at least {{minPasswordLength|convertNumberToWord}}
                                            characters
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12 mt-2">
                                <a href="javascript:void(0)" class="forgot-password-link">Forgot password?</a>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer justify-content-center">
                        <button mat-raised-button class="btn btn-primary btn-lg" type="submit">Submit</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>